export const LEAGUE_TV_LINK = 'https://app.tiled.co/microapps/5fc7d8bc7b2d5036f691f6c7';
